import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

export const CUSTOMER_GROUP_MEMBERS_TARGET_KIND = "customerGroupMembers";

export const CUSTOMERS_BASE_PATH = "/fulfill/customers";

export const CUSTOMERS_DOCK_PANEL_ID = "customers";

export const buildCustomerGroupMembersTarget = (customerGroupId: string): ContinuationTarget => ({
	listFilters: { customerGroupId },
	targetId: customerGroupId,
	targetKind: CUSTOMER_GROUP_MEMBERS_TARGET_KIND
});

export const buildCustomerGroupMembersFilterModel = (listFilters: Record<string, string> | undefined) =>
	listFilters?.customerGroupId
		? { customerGroupId: { filter: listFilters.customerGroupId, filterType: "text", type: "equals" } }
		: {};

const customerGroupMembersReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: () => CUSTOMERS_BASE_PATH,
	matchesRoute: () => null
};

export default customerGroupMembersReceiverIdentityAdapter;
